import { Injectable } from '@angular/core';
import { Cordova, IonicNativePlugin, Plugin } from '@ionic-native/core';
import { Observable } from 'rxjs';
/**
 * @name Apple Pay
 * @description
 * A dependency free Cordova plugin to provide Apple Pay functionality.
 *
 * @usage
 */
@Plugin({
    pluginName: 'AdyenPlugin',
    plugin: 'cordova-plugin-adyen',
    pluginRef: 'AdyenPlugin',
})
@Injectable()
export class AdyenPlugin extends IonicNativePlugin {
    
    @Cordova({
        otherPromise: true,
    })
    canMakePayments(): Promise<any> {
        return;
    }

    @Cordova({
        observable: true,
        clearFunction: 'stopListeningPaymentMethodChange',
    })
    startListeningPaymentMethodChange(): Observable<any> {
        return;
    }

    @Cordova({
        otherPromise: true,
    })
    stopListeningPaymentMethodChange(): Promise<boolean> {
        return;
    }

    @Cordova({
        otherPromise: true,
    })
    present(successCb: any, errorCb: any, paymentData: any): Promise<any> {
        return;
    }

    @Cordova({
        otherPromise: true,
    })
    initializeFees(successCb: any, errorCb: any, paymentData: any): Promise<any> {
        return;
    }
    @Cordova({
        otherPromise: true,
    })
    updateSummaryItems(successCb: any, errorCb: any, paymentData: any): Promise<any> {
        return;
    }
    @Cordova({
        otherPromise: true,
    })
    showApplePayFailed(successCb: any, errorCb: any): Promise<any> {
        return;
    }

    /**
     * Hand a 3DS redirect action to the native Adyen plugin to complete via
     * the platform-appropriate browser context (iOS: ASWebAuthenticationSession,
     * Android: Adyen3DSRedirectActivity WebView). Resolves the success
     * callback with `{ redirectResult }` (or `{ details: { redirectResult } }`
     * on Android).
     *
     * @param successCb  receives `{ redirectResult: string, ... }` on capture
     * @param errorCb    receives an error string on cancel/failure
     * @param paymentData `{ clientKey: string, environment: 'test' | '' }`
     * @param redirectAction Adyen action object `{ url, method?, data? }`
     */
    @Cordova({
        otherPromise: true,
    })
    handle3DSRedirect(successCb: any, errorCb: any, paymentData: any, redirectAction: any): Promise<any> {
        return;
    }

}



// WEBPACK FOOTER //
// ./src/providers/adyen/adyen-sdk.ts